import * as React from 'react';
// import { Row, AutoComplete, Button, Input, Icon } from 'antd';
import { Row, Select , Button, } from 'antd';
import '../../css/AutocompleteOrg.scss';
import strings from '../../eyeguide-localization/strings.common';

interface IAutoCompleteOrgsProps {
    options: any;
    showDashboard: any;
    orgMap: any;
}

interface IAutocompleteState {
    selectedOrgs: any;
    isSelectionOff: boolean;
    loading: boolean;
}

export default class AutoCompleteOrgs extends React.Component<IAutoCompleteOrgsProps, IAutocompleteState> {

    searching: boolean;
    selectedOrg: any;
    selectComp: any;
    constructor(props: IAutoCompleteOrgsProps ) {
        super(props);
        this.searching = true;
        this.onSearch = this.onSearch.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.state = {
            selectedOrgs: [],
            isSelectionOff: false,
            loading: false
        };
    }

    render() {
        setTimeout(() => {this.selectComp.focus() ; }, 1); 
        return (
            <Row className="AutocompleteOrg">
                {/* <AutoComplete
                    dropdownStyle={{ width: 500 }}
                    size="large"
                    dataSource={this.props.options}
                    placeholder="Type to search"
                    optionLabelProp="value"
                    onSelect={this.onSelect}
                    onSearch={this.onSearch}
                    filterOption={(inputValue: string, option: any) => option !== null && option !== undefined ?
                                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                        : ''}
                >

                <Input 
                    suffix={<Icon type="search"/>} 
                />

                </AutoComplete> */}
                <Select
                    ref={e => this.selectComp = e}
                    autoFocus={true}
                    mode="multiple"
                    style={{ width: '70%', paddingBottom: '10px' }}
                    placeholder={strings.lsSelectOrgTxt}
                    dropdownStyle={{ width: 500}}
                    onSelect={this.onSelect}
                    onSearch={this.onSearch}
                    value={this.state.selectedOrgs}
                    onChange={(val) => { console.log('val', val); this.handleOnChange(val); }}
                    getPopupContainer={this.getContainer}
                    filterOption={(inputValue: string, option: any) =>  
                        this.handleSearch(inputValue, option) } 
                >
                    {this.props.options}
                </Select>
                <Button 
                    onClick={() => this.showDashboard()} 
                    type="primary" 
                    className="confirmBtn"
                    loading={this.state.loading}
                > 
                    {strings.lsConfirmTxt} 
                </Button>
            </Row>
        );
    }

    private onSelect(value: any, option: any) {
        this.searching = false;
        if (!this.state.isSelectionOff) {
            this.selectedOrg = {key: option.key, value: option.props.children };
        }
        this.selectComp.blur();
        console.log('onSelect', value);
        console.log('option', option);
  
    }
  
    private onSearch(value: any) {
        this.searching = true;
        console.log('onSearch', value);
    }

    private async showDashboard() {
        if (!this.searching) {
            this.setState({
                loading: true
            });
            console.log('this.props.showDashboard(this.selectedOrg)', this.selectedOrg);
            this.searching = false;
            await this.props.showDashboard(this.selectedOrg);
            this.setState({
                loading: false
            });

        } else {
            console.log('please select');
        }
    }
    
    /**
     * sets the container element for dropdown menu
     */
    private getContainer = (triggernode) => {
        return triggernode.parentNode;
    }

    private handleOnChange(val: any) {
        console.log(val);
        if (val.length === 1) {
            this.setState({
                selectedOrgs: val[0],
                isSelectionOff: true
            });
        } else if (val.length === 0) {
            this.setState({
                selectedOrgs: [],
                isSelectionOff: false
            });
        }
    }

    private handleSearch(inputValue: string, option: any) {
        console.log('inputValue', inputValue);
        console.log('option', option);
        if ( option === null && option === undefined ) {
            return '';
        }

        let found =  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
        console.log('found1' ,  found);
        if ( !found && this.props.orgMap.has(option.props.children) ) {
              console.log('selected', option.props.children , this.props.orgMap[option.props.children]);
              this.props.orgMap.get(option.props.children).forEach(element => {
              found = found || element.name.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
            });          
        }
        console.log('found2' ,  found);
        return found;
    }
}



// WEBPACK FOOTER //
// ./src/components/common/autocompleteOrgs.tsx